import IconLinkToSite from '@icons/IconLinkToSite';
import {
  Button,
  ButtonSizes,
  ButtonVariants
} from 'stubben-edge-unified-frontend-react-components';
import React, { ReactNode } from 'react';

const Tooltip = ({
  tip,
  position,
  children,
  link,
  className,
  variant = 'light'
}: {
  tip: string;
  children?: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  link?: string;
  className?: string;
  variant?: 'light' | 'dark';
}) => {
  const getPositionClass = () => {
    switch (position) {
      case 'top':
        return 'tooltip-top';
      case 'bottom':
        return 'tooltip-bottom';
      case 'left':
        return 'tooltip-left';
      case 'right':
        return 'tooltip-right';
      default:
        return 'tooltip-top'; // Default to top position
    }
  };

  const variantClass = variant === 'dark' ? 'tooltip-wrapper--dark' : '';

  return (
    <>
      <div
        className={`tooltip-wrapper ${variantClass} ${className ?? ''}`.trim()}
      >
        {children}
        <div className={`tooltip ${getPositionClass()}`}>
          <span>{tip}</span>
          {link && (
            <div className="tooltip-btn">
              <Button
                variant={ButtonVariants.Link}
                leftSlot={<IconLinkToSite />}
                href={link}
                size={ButtonSizes.SM}
                className="!text-xs"
                testIdentifier="tooltip-learn-more"
              >
                Learn more
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Tooltip;
